import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useGlobalInfo } from "../contexts/GlobalInfoContext";
import { routes } from "../utilities/defaults/routes/routes";
import { isUser } from "../utilities/helper/roleHelper";
import Loader from "./loading/Loader";
import AdminProviders from "./providers/AdminProviders";

const AdminRoute = () => {
  const { isAuthenticated } = useAuth();
  const { userInfo, loading } = useGlobalInfo();

  if (loading || !userInfo) {
    return (
      <div className="grid w-full h-dvh place-content-center">
        <Loader />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to={routes.login.path} replace />;
  }

  if (isUser(userInfo)) {
    return <Navigate to={routes.dashboard.path} replace />;
  }

  return (
    <AdminProviders>
      <Outlet />
    </AdminProviders>
  );
};

export default AdminRoute;
